import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import { compose } from 'recompose';

import withPortal from '../withPortal';
import ChatMessage from '../../Model/ChatMessage';
import ClientDocument from '../../Model/ClientDocument';
import { AttachmentType } from '../../utils/attachments';
import ChatContext from '../../context/ChatContext';
import {
  Container,
  StyledModal,
  StyledText,
  ControlsContainer,
  StyledButtonContainer,
  StyledSecondaryButton,
  StyledPrimaryButton,
} from './styles';

import texts from './texts.json';

const DeleteMessageModal = ({ isOpen, onClose, message }) => {
  const {
    authUser,
  } = useContext(ChatContext);

  const handleDelete = async () => {
    try {
      await message.delete(authUser.id);
      const hasNonAudioAttachments = message.attachments.length > 0
        && message.attachments.some((a) => a.type !== AttachmentType.AUDIO);
      if (hasNonAudioAttachments) {
        await ClientDocument.removeByMessageId(message.id);
      }
    } finally {
      onClose();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Container>
      <StyledModal>
        <StyledText>
          {texts.areYouSure}
        </StyledText>
        <ControlsContainer>
          <StyledButtonContainer>
            <StyledSecondaryButton
              onClick={onClose}
              full={false}
            >
              {texts.cancel}
            </StyledSecondaryButton>
            <StyledPrimaryButton
              onClick={handleDelete}
              full={false}
            >
              {texts.delete}
            </StyledPrimaryButton>
          </StyledButtonContainer>
        </ControlsContainer>
      </StyledModal>
    </Container>
  );
};

DeleteMessageModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.instanceOf(ChatMessage).isRequired,
};

export default compose(
  withPortal('deleteMessageModal'),
)(DeleteMessageModal);
